import styled from 'styled-components'
import { Button } from '../../../components/shared/StyledComponents'
import { LinkedInAssignment } from '../../../services/api'
import { Chip, ESTADO_COLORS, ESTADO_LABELS } from './linkedinStyles'

const TARGET_LABELS: Record<string, string> = {
    repo: '💻 Repo',
    paper: '📄 Paper',
    project: '🧩 Proyecto',
}

const TableWrapper = styled.div`
  overflow-x: auto;
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.md};
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`

const Th = styled.th`
  text-align: left;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  background: ${({ theme }) => theme.colors.secondary};
  font-weight: 600;
  white-space: nowrap;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`

const Td = styled.td`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  vertical-align: middle;
`

const Row = styled.tr`
  &:hover { background: #fafafa; }
`

const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs};
  justify-content: flex-end;
`

const formatDate = (value?: string | null): string => {
    if (!value) return '—'
    const d = new Date(value)
    if (Number.isNaN(d.getTime())) return value
    return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

interface AssignmentsTableProps {
    assignments: LinkedInAssignment[]
    onEdit: (assignment: LinkedInAssignment) => void
    onClose: (assignment: LinkedInAssignment) => void
}

export const AssignmentsTable: React.FC<AssignmentsTableProps> = ({
    assignments,
    onEdit,
    onClose,
}) => (
    <TableWrapper>
        <Table>
            <thead>
                <tr>
                    <Th>Interno</Th>
                    <Th>Tipo</Th>
                    <Th>Objetivo</Th>
                    <Th>Inicio</Th>
                    <Th>Fin</Th>
                    <Th>Dedicación</Th>
                    <Th>Estado</Th>
                    <Th>Progreso</Th>
                    <Th style={{ textAlign: 'right' }}>Acciones</Th>
                </tr>
            </thead>
            <tbody>
                {assignments.map((a) => {
                    const estadoKey = a.estado || 'asignada'
                    const estadoStyle = ESTADO_COLORS[estadoKey] || ESTADO_COLORS.asignada
                    const isActive = !a.fecha_fin
                    return (
                        <Row key={a.id}>
                            <Td>{a.user_display_name || `Usuario #${a.user_id}`}</Td>
                            <Td>{TARGET_LABELS[a.target_type] ?? a.target_type}</Td>
                            <Td>{a.target_title || `#${a.target_id}`}</Td>
                            <Td>{formatDate(a.fecha_inicio)}</Td>
                            <Td>{formatDate(a.fecha_fin)}</Td>
                            <Td>{a.capacity_pct ?? 100}%</Td>
                            <Td>
                                <Chip $bg={estadoStyle.bg} $color={estadoStyle.color}>
                                    {ESTADO_LABELS[estadoKey] || estadoKey}
                                </Chip>
                            </Td>
                            <Td>{typeof a.progress_pct === 'number' ? `${a.progress_pct}%` : '—'}</Td>
                            <Td>
                                <Actions>
                                    <Button variant="secondary" size="sm" onClick={() => onEdit(a)}>
                                        Editar
                                    </Button>
                                    {isActive && (
                                        <Button variant="danger" size="sm" onClick={() => onClose(a)}>
                                            Cerrar
                                        </Button>
                                    )}
                                </Actions>
                            </Td>
                        </Row>
                    )
                })}
            </tbody>
        </Table>
    </TableWrapper>
)

export default AssignmentsTable
